import { render, staticRenderFns } from "./inspecttaskproject.vue?vue&type=template&id=1180fbb7&"
import script from "./inspecttaskproject.vue?vue&type=script&lang=js&"
export * from "./inspecttaskproject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports